import { connect } from 'react-redux';
import NetworkStateComponent from './network_state';
import withPGTranslation from '../../../config/withPGTranslation';

const mapStateToProps = ({ pubnub }) => pubnub;

export default connect(mapStateToProps)(withPGTranslation(NetworkStateComponent));
